module.exports = __webpack_public_path__ + "static/media/waterloo-logo.cb9abac6.png";